<div id="separator"></div>
<div [ngClass]="isMobile == true ? 'resolutions-holder-mob' : 'resolutions-holder'" style="margin-bottom: 24px;">
  <div class="top-holder">
    <h3 id="resolutions-header">{{'POLL-LIST.ONGOING' | translate}}</h3>
  </div>
  <app-poll-election-item (selected)="setActiveElection($event)" *ngFor="let election of elections; let i = index"
    [index]="i" [votedData]="responses[i]" [isMobile]="isMobile" [election]="election" [forceBlankVote]="forceBlankVote">
  </app-poll-election-item>
</div>
